module.exports = __webpack_public_path__ + "img/blog-main-06.2ed98695.jpg";